/// <reference path="api.d.ts" />

namespace API.Client {
    'use strict';

    export interface Country {

        /**
         * codigo do pais
         */
        "code"?: string;

        /**
         * nome do pais
         */
        "name"?: string;

        /**
         * country code IATA code
         */
        "iataCode"?: string;
    }

}
